import { ApplicationState } from "../store/app";
import { createSelector } from "./common.selectors";

export const getUserLocationStateCode = createSelector(
    (state: ApplicationState) => state.location,
    location => location.stateCode,
);
